import { useState } from 'react';
import { Button, Text } from '@vinted/web-ui';
import Banner from 'components/Banner';
import CancelRegistrationModal from './CancelRegistrationModal';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";

const BusinessAccountBanner = _ref => {
  let {
    banner
  } = _ref;
  const {
    0: isModalOpen,
    1: setIsModalOpen
  } = useState(false);
  const {
    title,
    body,
    continueButtonLabel,
    continueButtonUrl,
    cancelButtonLabel
  } = banner;

  function handleCancelClick() {
    setIsModalOpen(true);
  }

  function handleModalClose() {
    setIsModalOpen(false);
  }

  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx(Banner, {
      title: /*#__PURE__*/_jsx(Text, {
        text: title,
        type: Text.Type.Heading
      }),
      body: /*#__PURE__*/_jsx(Text, {
        text: body
      }),
      actions: [/*#__PURE__*/_jsx(Button, {
        text: continueButtonLabel,
        url: continueButtonUrl,
        styling: Button.Styling.Filled
      }), /*#__PURE__*/_jsx(Button, {
        text: cancelButtonLabel,
        onClick: handleCancelClick
      })]
    }), /*#__PURE__*/_jsx(CancelRegistrationModal, {
      isOpen: isModalOpen,
      onClose: handleModalClose
    })]
  });
};

export default BusinessAccountBanner;